import {
  HorizAlignment,
  ISearch,
  ISearchProfile,
  ISearchProvider, ISearchRequestSubset,
  SearchProviderFieldType
} from "../PA.UIM.Core/PA.UIM.Core.IF.Search"
import {PASearch, ISearchRequest} from "../PA.Core/PASearch";
import {SearchUtils} from "../PA.UIM.Core/SearchUtils";
import {PAEnvironment} from "../PA.Core/PAEnvironment";
import * as _ from "lodash";

const PlanningLevelSearchProviderPlanned: ISearchProvider = {

    keyFields: {id:    'PLANNING_LEVEL_ID',
                id_ui: 'PLANNING_LEVEL_ID',
                name:  'PLANNING_LEVEL_NAME'
    },

    searchProviderFields: {
        PLANNING_LEVEL_ID:       {type: SearchProviderFieldType.string, renderOptions: { columnName: 'Planning Level Id', columnResourceName: 'colPlanningLevelID',   alignment: HorizAlignment.Left}, domainOptions: { maxLength: 50}},
        PLANNING_LEVEL_NAME:     {type: SearchProviderFieldType.string, renderOptions: { columnName: 'Planning Level',    columnResourceName: 'colPlanningLevelName', alignment: HorizAlignment.Left}, domainOptions: { maxLength: 256}},
        WB_CUST_ID_PLANNING:     {type: SearchProviderFieldType.number},
        WB_SALESORG_ID:          {type: SearchProviderFieldType.number, renderOptions: { columnName: 'Sales Org WB Id', columnResourceName: 'colSalesOrgId', alignment: HorizAlignment.Center }, domainOptions: { } },
        },

  search(searchOptions: ISearchRequestSubset): Promise<any[]> {
    return new Promise<any[]>((resolve, error) => {
        let usrContext = PAEnvironment.getValue(PAEnvironment.UserContext)
        let salesorgs=_.map(usrContext.WB_SalesOrgs, 'WB_SALESORG_ID')

        let findRequest = SearchUtils.makeSearchRequest({where:{WB_SALESORG_ID:{inq: salesorgs}}},
        'vUI_Plan_Search',
        this.searchProviderFields,
        ['PLANNING_LEVEL_ID','PLANNING_LEVEL_NAME'])
        if (!usrContext.hasRoleId("VIEW_ALL"))
            SearchUtils.addUsrContextCustomerFilter(findRequest, 'WB_CUST_ID_PLANNING')

      PASearch.findByRequest(findRequest)
        .then((res: any[]) => {
          resolve(res)
        })
        .catch((err)=> {
          error(err)
        })
    })
  }




}


const PlanningLevelSearchProfileByName: ISearchProfile = {
    profileId: "default",
    profileName: "Planning Level",
    renderOptions: { ui5ResourceId: "PlanningLevelSearchProfileByName" },

    profileFilter: [
    ],  // ISearchFields
    profileDisplayFields: [
        'PLANNING_LEVEL_ID','PLANNING_LEVEL_NAME'
    ], //string[];   // Search Provider Field Name (Use to Generate Grid Columns)

    profileSearchProvider: PlanningLevelSearchProviderPlanned,

    // Do sorting last.. not necessary for phase 1
    profileSortIdDefault: "",    //string;
    profileSorts: [] //ISearchSort[];
}


const PlanningLevelSearch: ISearch = {
    searchName: "Find Planning Level",
    renderOptions: { ui5ResourceId: "PlanningLevelSearch"},
    searchProfileIdDefault: "default",
    searchProfiles: [PlanningLevelSearchProfileByName]
}
PAEnvironment.registerBusinessObjectSearch("PlanningLevelBO", "PlanningLevel", PlanningLevelSearch, "Planning Level Search")

export {PlanningLevelSearch}